import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelexportService {

  constructor() { }


  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public fact2Export(
    general: any[], comparativa: any[], diferencia: any[], excelFileName: string): void {

    const generalSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(general);
    const comparativaSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(comparativa);
    const diferenciaSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(diferencia);

    const workbook: XLSX.WorkBook = {
      Sheets: {
        'general': generalSheet,
        'comparativa' : comparativaSheet,
        'diferencia' : diferenciaSheet
      },
      SheetNames: ['general', 'comparativa', 'diferencia']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_' + EXCEL_EXTENSION);
  }

  private formatDate() {
    let d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
}

  public export2Chart(json: any[], excelFileName: string): void {

    const worksheet1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[0]['data']);
    const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[1]['data']);
    const worksheet3: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[2]['data']);
    const worksheet4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[3]['data']);
    const worksheet5: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[4]['data']);
    const worksheet6: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[5]['data']);
    const worksheet7: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[6]['data']);
    const worksheet8: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[7]['data']);
    const worksheet9: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[8]['data']);
    const worksheet10: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json[9]['data']);

    const workbook: XLSX.WorkBook = { 
      Sheets: { 
        "E. T. fact. total": worksheet1,
        "E. T. pot. fact.": worksheet2,
        "E. T. ener. activa": worksheet3,
        "E. T. ener. reactiva": worksheet4,
        "E. prec. pot.": worksheet5,
        "E. prec. ener. activa": worksheet6,
        "€ ahorrado diario acum": worksheet7,
        "E. pot. fact.": worksheet8,
        "Evolución ener. activa": worksheet9,
        "E. ener. reactiva fact.": worksheet10
       }, 
      SheetNames: ["E. T. fact. total",
      "E. T. pot. fact.",
      "E. T. ener. activa",
      "E. T. ener. reactiva",
      "E. prec. pot.",
      "E. prec. ener. activa",
      "€ ahorrado diario acum",
      "E. pot. fact.",
      "Evolución ener. activa",
      "E. ener. reactiva"] 
      };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
    
  }

  public export2DT(json: any[], excelFileName: string): void {

    const worksheet1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { 
      Sheets: { "Ejemplo": worksheet1 }, 
      SheetNames: ["Ejemplo"] 
      };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public createWorkSheet(json){
    let worksheet: XLSX.WorkSheet;
    worksheet = XLSX.utils.json_to_sheet(json);
    return worksheet;
  }

  public exportZkUsers(json: any[], excelFileName: string): void {

    let workbook: XLSX.WorkBook = { Sheets: {}, SheetNames: [] };

    for (let index = 0; index < json.length; index++) {
      workbook.Sheets[json[index]['name'] + '_resumen'] = this.createWorkSheet(json[index]['resumen']);
      workbook.Sheets[json[index]['name'] + '_total'] = this.createWorkSheet(json[index]['totales']);
      workbook.SheetNames.push(json[index]['name'] + '_total');
      workbook.SheetNames.push(json[index]['name'] + '_resumen');
    }

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportCuadranteWithTotal(json: any[],total: any[], excelFileName: string): void {

    const worksheet1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(total);
    const workbook: XLSX.WorkBook = { 
      Sheets: {
        "Detalle": worksheet1,
        "Resumen" : worksheet2
      }, 
      SheetNames: ["Detalle","Resumen"] 
      };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  

}
